import {useMemo} from 'react';
import { useSelector } from 'react-redux';

const selectStrings = state => state.strings;
export function useString(key) {
    const strings = useSelector(selectStrings);
    return useMemo(() => {
        return strings[key];
    }, [strings, key]);
}
